import React, { useMemo, useRef } from "react";
import styles from "../Detail.module.scss";
import classNames from "classnames/bind";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";
import { Row, StatsRow } from "./Rows";

const cx = classNames.bind(styles);

export const Card = ({ icon, title, period, rows, expanded, innerRef, type, chart, chartLabels }) => {
  const rowsToRender = useMemo(() => {
    if (expanded) return rows;
    if (type === "facebook") {
      const hiddenKeys = new Set([
        "page_impressions_organic_unique",
        "page_impressions_paid_unique",
      ]);
      return (rows || []).filter((r) => !hiddenKeys.has(r.key));
    }
    return rows;
  }, [rows, expanded, type]);

  const impressionsLabel = chartLabels?.impressions ?? "Lượt hiển thị";
  const reachLabel = chartLabels?.reach ?? "Tiếp cận";

  return (
    <div ref={innerRef} className={cx("card")}>
      <div className={cx("logo")}>{icon}</div>
      <div className={cx("cardContent")} data-expanded={expanded ? "true" : "false"}>
        <div className={cx("header")}>
          <div className={cx("headerLeft")}> <span>{title}</span> </div>
          <div className={cx("period")}>{period}</div>
        </div>

        {expanded && Array.isArray(chart) && chart.length > 0 && (
          <div className={cx("chart")}>
            <ResponsiveContainer width="100%" height={typeof window !== 'undefined' && window.innerWidth <= 768 ? 160 : 200}>
              <LineChart data={chart}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" tick={{ fontSize: (typeof window !== 'undefined' && window.innerWidth <= 768) ? 10 : 11 }} />
                <YAxis tick={{ fontSize: (typeof window !== 'undefined' && window.innerWidth <= 768) ? 10 : 11 }} />
                <Tooltip contentStyle={{ fontSize: (typeof window !== 'undefined' && window.innerWidth <= 768) ? 11 : 12 }} />
                <Legend wrapperStyle={{ fontSize: (typeof window !== 'undefined' && window.innerWidth <= 768) ? 11 : 12 }} />
                <Line type="linear" dataKey="impressions" name={impressionsLabel} stroke="#2483f2" strokeWidth={2} dot={false} />
                <Line type="linear" dataKey="reach" name={reachLabel} stroke="#16a34a" strokeWidth={2} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        )}

        <div className={cx("table")} data-show-pct={expanded ? "true" : "false"}>
          {rowsToRender.map((r, idx) => (
            expanded ? (
              r.combined ? (
                <div key={idx} className={cx("row", "reachCombined")}>
                  <div className={cx("cellLabel")}>{r.label}:</div>
                  <div className={cx("cellValue")}>
                    {r.value}
                    <div className={cx("subLabel")}>{r.orgLabel}:</div>
                    <div className={cx("cellValue", r.orgDir === "up" ? "up" : "down")}>{r.orgValue}</div>
                    <div className={cx("subLabel")}>{r.paidLabel}:</div>
                    <div className={cx("cellValue", r.paidDir === "up" ? "up" : "down")}>{r.paidValue}</div>
                  </div>
                  <div className={cx("status")}>{r.dir === "up" ? "tăng" : "giảm"}</div>
                  <div className={cx("delta", r.dir === "up" ? "up" : "down")}>{r.delta}</div>
                  <div className={cx("pct", r.dir === "up" ? "up" : "down")}>{r.pct ?? "-"}</div>
                </div>
              ) : (
                (() => { const { key: _metricKey, ...rest } = r || {}; return <StatsRow key={idx} {...rest} />; })()
              )
            ) : (
              (() => { const { key: _metricKey, ...rest } = r || {}; return <Row key={idx} {...rest} />; })()
            )
          ))}
        </div>
      </div>
    </div>
  );
};

export const CardItem = ({ item, expanded, onToggle, period }) => {
  const ref = useRef(null);

  return (
    <div className={cx("cardWrap")} data-expanded={expanded ? "true" : "false"} onClick={onToggle}>
      <div className={cx("scaleBox")} data-expanded={expanded ? "true" : "false"}>
        <Card
          innerRef={ref}
          expanded={expanded}
          type={item.type}
          icon={item.icon}
          title={item.title}
          period={period}
          rows={item.rows}
          chart={item.chart}
          chartLabels={item.chartLabels}
        />
      </div>
    </div>
  );
};
